import { useState } from 'react'

export const useRegisterDetailsModal = () => {
  const [registerDetailsModal, setRegisterDetailsModal] = useState<boolean>(false)

  const handleCloseModal = () => {
    setRegisterDetailsModal(false)
  }

  const handleOpenModal = () => {
    setRegisterDetailsModal(true)
  }

  return {
    registerDetailsModal,
    handleCloseModal,
    handleOpenModal
  }
}
